import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "./fordon";

export const Route = createFileRoute("/anvandarvillkor")({
  head: () => ({
    meta: [
      { title: "Användarvillkor – AK Husbil & Fritid" },
      {
        name: "description",
        content:
          "Villkor för användning av webbplatsen akhusbilfritid.se — ansvar, upphovsrätt, länkar och tillämplig lag.",
      },
      { property: "og:title", content: "Användarvillkor – AK Husbil & Fritid" },
      {
        property: "og:description",
        content: "Villkor för användning av akhusbilfritid.se.",
      },
      { property: "og:url", content: "https://www.akhusbilfritid.se/anvandarvillkor" },
    ],
    links: [{ rel: "canonical", href: "https://www.akhusbilfritid.se/anvandarvillkor" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <>
      <PageHeader
        label="Juridik · Villkor"
        title={<>Användar<span className="font-italic-display text-accent">villkor</span>.</>}
        sub="Genom att använda akhusbilfritid.se godkänner du villkoren nedan."
      />

      <article className="container-edge max-w-3xl py-16 md:py-20">
        <p className="text-sm text-muted-foreground">Senast uppdaterad: {new Date().toLocaleDateString("sv-SE")}</p>

        <div className="mt-10 space-y-10 [&_h2]:font-display [&_h2]:text-2xl md:[&_h2]:text-3xl [&_p]:mt-3 [&_p]:text-foreground/85 [&_a]:text-accent [&_a]:underline-offset-4 hover:[&_a]:underline">
          <section>
            <h2>1. Innehållets karaktär</h2>
            <p>
              Information om fordon, priser och tillgänglighet på denna webbplats är upplysande och utgör inte
              ett bindande erbjudande. Vi reserverar oss för felskrivningar, prisändringar och mellanförsäljning.
              Bekräftelse sker alltid skriftligen eller per telefon.
            </p>
          </section>
          <section>
            <h2>2. Upphovsrätt</h2>
            <p>
              Text, bilder, logotyper och grafik tillhör AK Husbil &amp; Fritid eller respektive rättighetshavare.
              Återanvändning kräver vårt skriftliga godkännande.
            </p>
          </section>
          <section>
            <h2>3. Länkar och tredjepartstjänster</h2>
            <p>
              Webbplatsen kan innehålla länkar till externa sajter (t.ex. Fyndanu, Blocket) och visa annonser
              via Google AdSense. Vi ansvarar inte för innehåll, produkter eller tjänster hos tredje part.
            </p>
          </section>
          <section>
            <h2>4. Ansvarsbegränsning</h2>
            <p>
              Vi strävar efter att hålla informationen korrekt och uppdaterad, men lämnar inga garantier för
              fullständighet eller felfrihet. Vi ansvarar inte för skador som uppstår genom användning av
              webbplatsen i den utsträckning lagen tillåter.
            </p>
          </section>
          <section>
            <h2>5. Personuppgifter</h2>
            <p>
              Behandling av personuppgifter beskrivs i vår <a href="/integritetspolicy">integritetspolicy</a>.
            </p>
          </section>
          <section>
            <h2>6. Tillämplig lag</h2>
            <p>
              Svensk lag tillämpas. Tvist avgörs av allmän domstol med Luleå tingsrätt som första instans.
            </p>
          </section>
        </div>
      </article>
    </>
  );
}
